import Api from './Api';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const convertToJob = async (data, token,showLoading = null,hideLoading = null,navigate = null,getRoutePath = null) => {
  const apiInstance = Api(() => token);
  
  if (!apiInstance) return;
  showLoading()
  try {
    const response = await apiInstance.call('convert-to-job', 'POST', data, true, false);
    
    if (response?.status === 200) {
      toast.success(response?.data?.message);
      navigate(getRoutePath(`/jobs`));
    } else {
      toast.error(response?.data?.message || 'Something went wrong');
    }
    hideLoading()
  } catch (error) {
    let errorMessage = 'Unexpected error occurred';
  
    // If backend sent HTML instead of JSON
    if (error?.response?.data) {
      if (typeof error.response.data === 'string' && error.response.data.startsWith('<!DOCTYPE')) {
        errorMessage = 'Server error (HTML response received)';
      } else {
        errorMessage = error?.response?.data?.message || errorMessage;
      }
    } else if (error?.message) {
      errorMessage = error.message;
    }
    hideLoading()
    toast.error(errorMessage);
     
  }
  
};
